import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

const ActionModal = ({
  open,
  title,
  onClose,
  onSubmit,
  submitLabel,
  cancelLabel,
  submitDisabled,
  submitting,
  children,
  maxWidth,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="default" disabled={submitting}>
        {cancelLabel}
      </Button>
      <Button onClick={onSubmit} color="primary" variant="contained" disabled={submitDisabled || submitting}>
        {submitting ? "送信中..." : submitLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

ActionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  submitDisabled: PropTypes.bool,
  submitting: PropTypes.bool,
  children: PropTypes.node,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
};

ActionModal.defaultProps = {
  submitLabel: "送信",
  cancelLabel: "キャンセル",
  submitDisabled: false,
  submitting: false,
  children: null,
  maxWidth: "sm",
};

export default ActionModal;
